<template>
    <div class="com-part1">
			<!-- <title1 type="2" title="订单统计" style="margin-top: 20px ;font-size:30px" />
        <div class="flex justify-content pue-content mt-20 align-items">
            <div class="flex align-items itemBox" v-for="(item,index) in target" :key="'item'+index">
                <img class="img" :src="require(`@/assets/images/computility/overview-add.png`)" alt="">
                <div class="flex flex-direction box align-items">
                    <span class="num font">{{item.number}}</span>
                    <span class="name">{{item.label}}</span>
                </div>
            </div>
        </div> -->
        <title1  type="2" title="订单统计" style="margin-top: 100px;font-size:30px" />
        <dv-scroll-board class="mt-80" :config="config" style="width:100%;height:420px">
		</dv-scroll-board>
    </div>
</template>

<script>
import title1 from '@/views/exposition/components/title2'
// import MyTitle from '../myTitle.vue'
import mySmallTitle from '../mySmallTitle1.vue'
import mySmallTitle1 from '../mySmallTitle.vue'
import { dataInterface } from "@/api/dataInterfaceApi"
export default {
    components: {
		title1,
        // MyTitle,
        mySmallTitle,
        mySmallTitle1
    },
    data() {
        return {
            config: {
				headerBGC: "rgba(53, 149, 147, 0.2)",
				headerHeight: 62,
				carousel: "single",
				hoverPause: true,
				oddRowBGC: "rgba(53, 149, 147, 0)",
				evenRowBGC: "#262F34",
				rowNum: 5, //表格行数
				header: ["客户名称", "订单内容", "下单时间"],
                align: ["center","center","center"],
				data: [],
			},
            newData:[],
            target:[
                {
                    label:'今日新增',
                    number: ''
                },
                {
                    label:'当月新增',
                    number: ''
                }
            ]
        }
    },
	mounted() {
        this.getData()
    },
	methods: {
        getData(){
            this.selectStationAlarmList0();
            this.selectStationAlarmList1();
            this.selectStationAlarmList();
        },
        // 字体动态
        dvDigitalFlopConfig(item = {}) {
            let counts = parseFloat(item.value || 0)
            let config = {
                number: [parseFloat(counts)],
                textAlign: item.textAlign || 'center',
                style: {
                    fill: item.color || '#fff',
                    fontSize: item.fontSize || 32,
					fontFamily: 'DS-Digital-Bold'
                }
            }
            console.log('==config==', config)
            return config
        },
        formatName(name,start = 1,end = 1,strCode = '*') {
            let newStr;
            if (name.length === 2) {
            newStr = name.substr(0, 1) + strCode;
            } else if (name.length > 2) {
            let char = '';
            for (let i = 0, len = name.length - 2; i < len; i++) {
                char += strCode;
            }
            newStr = name.substr(0, start) + char + name.substr(name.length - end);
            } else {
            newStr = name;
            }

            return newStr;
        },
        selectStationAlarmList0(data = {}) {
			let _this = this;
			let params = {
                "enCode": "computingpower-left-ddtj",
            }
			dataInterface
				.dataFaceApi(params)
				.then((res) => {
					if (!res) return;
                    console.log(res, '订单统计')
                    this.target[0].number = res[0].new_add_day || '-'
                    this.target[1].number = res[0].new_add_month || '-'
				})  
				.catch((err) => {
					console.log(err);
				});
		},
        selectStationAlarmList1(data = {}) {
			let _this = this;
			let params = {
                "enCode": "computingpower-left-khtj",
            }
			dataInterface
				.dataFaceApi(params)
				.then((res) => {
					if (!res) return;
					// console.log("客户统计", res)
                    let data = res.sort((a,b) => {
                        return a.rn - b.rn
                    })
                    console.log(data, 'data')
                    this.newData = data.map(item =>{
                        return {
                            sum_time:Number(item.sum_time).toFixed(0),
                            user_name:item.user_name
                        }
                        // console.log(Number(item.sum_time).toFixed(0), 'number')
                    })
                    console.log(this.newData, 'newData')
				})  
				.catch((err) => {
					console.log(err);
				});
		},
        selectStationAlarmList(data = {}) {
			let _this = this;
			let params = {
                "enCode": "computingpower-left-ddmx",
            }
			dataInterface
				.dataFaceApi(params)
				.then((res) => {
					if (!res) return;
					console.log("订单明细", res)
					let newList = [];
					[...res].map(item => {
						let arrlist = [
							this.formatName(item.user_name,1,2,'x'),
							item.order_content,
							item.order_time,
						];
						newList.push(arrlist)
					});
					_this.config = {
						headerBGC: "rgba(53, 149, 147, 0.2)",
						headerHeight: 42,
						carousel: "single",
						hoverPause: true,
						oddRowBGC: "rgba(53, 149, 147, 0)",
						evenRowBGC: "rgba(53, 149, 147, 0)",
                        align: ["center","center","center"],
						rowNum: 5, //表格行数
						header: ["客户名称", "订单内容", "下单时间"],
						data: newList,
					};
				})
				.catch((err) => {
					console.log(err);
				});
		},
    }
}
</script>

<style lang="scss" scoped>
@import '../comm.scss';
.com-part1 {
    width: 100%;
    height: 100%;
    .pue-list {
        height: 516px;
        background: red;
        background: url(~@/assets/images/computility/Podium.png) center no-repeat;
        position: relative;
        .Podium-1,.Podium-2,.Podium-3{
            position: absolute;
            font-size: $FontSize24;
        }
        .Podium-num-1,.Podium-num-2,.Podium-num-3{
            position: absolute;
            font-size: $FontSize40;
            @include ffamily-DS;
        }
        .Podium-1{
            top: -20px;
            left: 415px;
        }
        .Podium-2{
            top: 55px;
            left: 182px;
        }
        .Podium-3{
            top: 105px;
            left: 645px;
        }
        .Podium-num-1{
            top: 235px;
            left: 385px;
        }
        .Podium-num-2{
            top: 300px;
            left: 150px;
        }
        .Podium-num-3{
            top: 340px;
            left: 610px;
        }
    }
    .pue-content{
        height: 200px;
        img{
            width: 162px;
            height: 155px;
        }
        .box{
            width: 150px;
            height: 100%;
            .name{
                font-size: $FontSize24;
            }
            .num{
                font-size: $FontSize50;
                @include ffamily-DS;
            }
            .font{
                @include ffamily-DS;
            }
        }
    }
    .dv-scroll-board ::v-deep .header{
        font-size: $FontSize24;
    }
    .dv-scroll-board ::v-deep .rows .row-item{
        font-size: $FontSize24;
    }
    
}
.img{
    animation: breath_light 3s ease infinite;
}
</style>